import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type ReviewDTO = {
    name:string;
    review: string;
    rating: number;
};

type ReviewResponse = {
    id:string;
    rating: number;
    name:string;
    review: string;
    createdAt:string;
    updatedAt:string
} & ApiError;

export const CreateReview = (data: ReviewDTO[]): Promise<ReviewDTO> => {
    return axios.post("/review/create", data)
        .then(response => response.data as ReviewResponse);
};
